import React from 'react';
import { Button, Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { Metric } from "../../../../metric";
import style from "./styles.pcss";
var cn = classNames.bind(style);
export var RegionList = function RegionList(_ref) {
  var regions = _ref.regions,
    _onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('regions'),
    "data-t-id": "components-RegionList"
  }, regions.map(function (columnRegions, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('regions-group'),
      key: index
    }, columnRegions.map(function (_ref2) {
      var groupName = _ref2.groupName,
        items = _ref2.items;
      return /*#__PURE__*/React.createElement("div", {
        key: groupName
      }, /*#__PURE__*/React.createElement(Text, {
        className: cn('group-title'),
        lineHeight: 28,
        size: 24
      }, groupName.toLowerCase()), /*#__PURE__*/React.createElement("ul", {
        className: cn('region-list')
      }, /*#__PURE__*/React.createElement("li", {
        className: cn('region-list__item')
      }, items.map(function (region) {
        return /*#__PURE__*/React.createElement(Metric, {
          asChild: true,
          data: region.title,
          events: {
            headerMetric: ['handleChosenRegionClick']
          },
          key: "".concat(region.title, "_").concat(region.code),
          mode: "click"
        }, /*#__PURE__*/React.createElement(Button, {
          mode: "inline",
          onClick: function onClick() {
            return _onClick(region);
          },
          tagName: "a",
          view: "secondary",
          "data-t-id": "components-RegionList"
        }, /*#__PURE__*/React.createElement(Text, {
          className: cn('region-list__link'),
          color: "primary-invert",
          lineHeight: 20,
          size: 16,
          "data-t-id": "components-RegionList"
        }, region.title)));
      }))));
    }));
  }));
};